import { Component } from '@angular/core';
import { FormsModule, NgForm } from '@angular/forms';
import { GetUseRoleService } from '../../../services/get-UseRole/get-use-role.service';
import { GetUserResponseInterface } from '../../../interfaces/get-UseRole.interface';
import { CommonModule, NgFor } from '@angular/common';
import { LoadingService } from '../../../services/general/loading.service';
import { LogTackingService } from '../../../services/logs/log-tacking.service'
import { LogsTrackingRequest, LogsTrackingResponse } from '../../../interfaces/logs_tracking.interface.';
import { ErrorAlertComponent } from "../../shared/error-alert/error-alert.component";
import { UsernameExtractorPipe } from '../../../pipes/username-extractor.pipe';
import { ResultsModalComponent, TableData } from '../../shared/results-modal/results-modal.component';
import { PageHeaderComponent } from '../../shared/page-header/page-header.component';

@Component({
  selector: 'app-get-use-role',
  standalone: true,
  imports: [CommonModule, FormsModule, ErrorAlertComponent, UsernameExtractorPipe, ResultsModalComponent, PageHeaderComponent],
  templateUrl: './get-use-role.component.html',
  styleUrl: './get-use-role.component.css'
})
export class GetUseRoleComponent {
  addons: GetUserResponseInterface[] = [];
  token: string = '';
  nitInput: string = '';
  showAlertError: boolean = false;
  errorMessage = ''
  showResultsModal: boolean = false;
  tableData: TableData | null = null;
  headerInfo: string = '';
  log_info: LogsTrackingRequest = {
    email: localStorage.getItem('userName') ?? '',
    action: 'Consultar Usuarios Cuenta',
    details: '',
    ip_address: localStorage.getItem('ip') ?? ''
  }

  constructor(
    private getUserRoleService: GetUseRoleService,
    private _loadingService: LoadingService,
    private _logsService: LogTackingService
  ) { }

  ngOnInit(): void {
    this.token = localStorage.getItem('authToken') ?? '';
  }

  onSubmit(form: NgForm) {
    this._loadingService.setLoading(true)
    this.getUserRoleService.getUserRole(this.token, this.nitInput).subscribe({
      next: (response: GetUserResponseInterface) => {
        this.addons = [response]; // Asignamos la respuesta directamente al array
        this._loadingService.setLoading(false)
        this.log_info.details = `Success: Usuario obtuvo con exito usuarios de la cuenta ${this.nitInput}`
        this.createTrackingLog()
        for (let addon of this.addons) {
          for (let user of addon.response) {
            user.full_name = this.capitalizarNombres(user.full_name)
            switch (user.identity_verification_status) {
              case 'SUCCESSFUL':
                user.identity_verification_status = 'VERIFICADO'
                break;
              case 'FAILED':
                user.identity_verification_status = 'FALLIDO'
                break;
              case 'REQUIRED':
                user.identity_verification_status = 'REQUERIDO'
                break;
              case 'IN_EXECUTION':
                user.identity_verification_status = 'EN EJECUCION'
                break;
            }
            switch (user.account_status) {
              case 'CONFIRMED':
                user.account_status = 'CONFIRMADO'
                break;
              case 'COMPROMISED':
                user.account_status = 'COMPROMETIDO'
                break;
              case 'ARCHIVED':
                user.account_status = 'ARCHIVADO'
                break;
              case 'PENDING':
                user.account_status = 'PENDIENTE'
                break;
            }
          }
        }
        if (typeof response.response === 'string') {
          if (response.response === `No se encontro informacion para ${this.nitInput}`)
            this.showErrorComponent(form)
        } else {
          // Preparar datos para el modal
          const nitLimpio = this.addons[0].cliente.replace('_NIT_USER', '');
          this.headerInfo = `NIT: ${nitLimpio}`;
          this.tableData = {
            columns: [
              { header: '', key: 'index' },
              { header: 'NOMBRE', key: 'full_name' },
              { header: 'ROL', key: 'role_info.name' },
              { header: 'CORREO ELECTRÓNICO', key: 'email' },
              { header: 'VALIDACIÓN IDENTIDAD', key: 'identity_verification_status' },
              { header: 'ESTADO DEL USUARIO', key: 'account_status' },
              { header: 'NÚMERO TELEFÓNICO', key: 'phone_number' },
              { header: 'NOMBRE USUARIO', key: 'username' }
            ],
            rows: this.addons[0].response
          };
          this.showResultsModal = true;
        }
      },
      error: (err) => {
        this.errorMessage = `${err.error.error} para el NIT ${this.nitInput}`
        this.log_info.details = `Error: ${this.errorMessage}`
        this.showErrorComponent(form)
      }
    });
  }

  cancel(form: NgForm) {
    this.nitInput = '';
    this.addons = [];
    form.resetForm();
  }

  closeResultsModal() {
    this.showResultsModal = false;
  }

  createTrackingLog() {
    this._logsService.generateTrackingLog(this.log_info).subscribe({
      next: (response: LogsTrackingResponse) => { },
      error: (error) => {
        console.log(error);
      }
    });
  }

  showErrorComponent(form: NgForm) {
    this._loadingService.setLoading(false);
    this.createTrackingLog()
    this.showAlertError = true
    setTimeout(() => {
      this.showAlertError = false;
      this.cancel(form)
    }, 8000);
  }

  capitalizarNombres(cadena: string): string {
    return cadena
      .toLowerCase()
      .split(' ') // 
      .map((palabra: string) =>
        palabra.charAt(0).toUpperCase() + palabra.slice(1))
      .join(' ');
  }
}
